const initialState = {
    loginResponse: {},
    DocumentFetch: {},
    FetchEmail: {},
    FetchImage: {},
    fetchTimeEntries: {},
    fetchOrgId: {},
    FetchWorkedHours: {},
    selectedLocationFilter: null, // Global location filter - stores location_id
    locationFilterData: null, // Stores full location object for display purposes
    superAdminSelectedOrgId: null, // Super Admin selected org filter - stores org_id
    superAdminSelectedOrgData: null, // Stores full org object for display purposes
    // Organization suspension state
    orgSuspensionStatus: {
        isSuspended: false,
        suspensionReason: null,
        suspendedAt: null,
    },
}


const loanReducer = ( state = initialState, action ) => {

    switch ( action.type ) {
        case "LOGIN_RESPONSE":
            return {
                ...state,
                loginResponse: action.payload
            };

            case "Document":
                return {
                    ...state,
                    DocumentFetch: action.payload,
                };
            case "Email_ID":
                return {
                    ...state,
                    FetchEmail: action.payload,
                };
            case "Image_Data":
                return {
                    ...state,
                    FetchImage: action.payload,
                };
            case "TIME_ENTRIES":
                return {
                    ...state,
                    fetchTimeEntries: action.payload,
                };
            case "ORG_ID":
                return {
                    ...state,
                    fetchOrgId: action.payload,
                };
            case "Worked_Hours":
                return {
                    ...state,
                    FetchWorkedHours: action.payload,
                };
            case "REGISTER_PAYLOAD":
                return {
                    ...state,
                    RegisteredPayload: action.payload,
                };
                case "APPROVAL_DATA":
                    return {
                        ...state,
                        ApprovalData: action.payload,
                    };
                case "ORGANISATION_DATA":
                    return {
                        ...state,
                    OrgData: action.payload,
                    };
                case "SET_LOCATION_FILTER":
                    return {
                        ...state,
                        selectedLocationFilter: action.payload.locationId,
                        locationFilterData: action.payload.locationData,
                    };
                case "CLEAR_LOCATION_FILTER":
                    return {
                        ...state,
                        selectedLocationFilter: null,
                        locationFilterData: null,
                    };
                case "SET_SUPERADMIN_ORG_FILTER":
                    return {
                        ...state,
                        superAdminSelectedOrgId: action.payload.orgId,
                        superAdminSelectedOrgData: action.payload.orgData,
                        // Clear location filter when org changes
                        selectedLocationFilter: null,
                        locationFilterData: null,
                    };
                case "CLEAR_SUPERADMIN_ORG_FILTER":
                    return {
                        ...state,
                        superAdminSelectedOrgId: null,
                        superAdminSelectedOrgData: null,
                        selectedLocationFilter: null,
                        locationFilterData: null,
                    };
                case "SET_ORG_SUSPENSION_STATUS":
                    return {
                        ...state,
                        orgSuspensionStatus: {
                            isSuspended: action.payload.isSuspended,
                            suspensionReason: action.payload.suspensionReason,
                            suspendedAt: action.payload.suspendedAt,
                        },
                    };
                case "CLEAR_ORG_SUSPENSION_STATUS":
                    return {
                        ...state,
                        orgSuspensionStatus: {
                            isSuspended: false,
                            suspensionReason: null,
                            suspendedAt: null,
                        },
                    };
        default:
            return state;

    }

}

export default loanReducer; 